// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2QQo3","errorLogs":"EditorFooter_errorLogs__P6YvG"};